(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[58],{

/***/ 83719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91164);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56727);
/* harmony import */ var components_atoms_ButtonNew__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30852);
/* harmony import */ var _Icon_fi_FiChevronDown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49604);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["data", "children", "activeIndex", "labelValue", "buttonExtendedClass"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var Dropdown = function Dropdown(_ref) {
  var data = _ref.data,
      _children = _ref.children,
      activeIndex = _ref.activeIndex,
      labelValue = _ref.labelValue,
      buttonExtendedClass = _ref.buttonExtendedClass,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Listbox */ .Ri, _objectSpread(_objectSpread({}, props), {}, {
    as: "div",
    className: props.className ? props.className : " dropdown-default",
    onChange: props.onChange ? props.onChange : function () {},
    children: function children(_ref2) {
      var open = _ref2.open;
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Listbox.Button */ .Ri.Button, {
          className: "relative w-full select-none pl-4  pr-9 text-left font-medium leading-6 h-full".concat(buttonExtendedClass ? " ".concat(buttonExtendedClass) : ""),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            className: open ? "text-bbc-brand-700" : "text-bbc-brand-800",
            children: labelValue && labelValue !== "" ? labelValue : activeIndex
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_Icon_fi_FiChevronDown__WEBPACK_IMPORTED_MODULE_2__/* .FiChevronDown */ .b, {
            className: "absolute right-4 top-1/2 float-right -translate-y-1/2 transform align-middle text-bbc-brand-500  ".concat(open ? "rotate-180" : "rotate-0", " transition-all duration-200"),
            size: 20
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Transition */ .uT, {
          leave: "transition-all duration-200 ease-out",
          leaveFrom: "transform  opacity-50",
          leaveTo: "transform  opacity-0",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Listbox.Options */ .Ri.Options, {
            className: "absolute z-10 mt-1 w-full select-none ".concat(props.optionsClass),
            style: props.optionsStyle,
            as: "div",
            children: _children ? _children : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
              className: " rounded-b-xl  bg-white pb-2",
              children: Array.isArray(data) && data.map(function (item, index) {
                if (item.title != activeIndex) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Listbox.Option */ .Ri.Option, {
                    value: item.uri,
                    as: "div",
                    className: "block cursor-pointer",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_ButtonNew__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                      as: "a",
                      variant: "ghost",
                      href: item.uri,
                      useRouter: true,
                      btnDisplay: "block",
                      btnTextColor: "text-bbc-brand-700 hover:text-bbc-brand-500",
                      btnPadding: "px-4 py-2",
                      btnTextWeight: "font-normal",
                      children: item.title
                    })
                  }, index);
                }

                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {});
              })
            })
          })
        })]
      });
    }
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (Dropdown);
Dropdown.defaultProps = {
  labelValue: null,
  data: [],
  buttonExtendedClass: null,
  activeIndex: "No thing to choose"
};
/** ========== */

/***/ }),

/***/ 59699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ FaCheckCircle; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FaCheckCircle(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 73579:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _defineProperty = __webpack_require__(61682);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = noSSR;
exports["default"] = dynamic;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _loadable = _interopRequireDefault(__webpack_require__(23668));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var isServerSide = false;

function noSSR(LoadableInitializer, loadableOptions) {
  // Removing webpack and modules means react-loadable won't try preloading
  delete loadableOptions.webpack;
  delete loadableOptions.modules; // This check is necessary to prevent react-loadable from initializing on the server

  if (!isServerSide) {
    return LoadableInitializer(loadableOptions);
  }

  var Loading = loadableOptions.loading; // This will only be rendered on the server side

  return function () {
    return /*#__PURE__*/_react["default"].createElement(Loading, {
      error: null,
      isLoading: true,
      pastDelay: false,
      timedOut: false
    });
  };
}

function dynamic(dynamicOptions, options) {
  var loadableFn = _loadable["default"];
  var loadableOptions = {
    // A loading component is not required, so we default it
    loading: function loading(_ref) {
      var error = _ref.error,
          isLoading = _ref.isLoading,
          pastDelay = _ref.pastDelay;
      if (!pastDelay) return null;

      if (false) {}

      return null;
    }
  }; // Support for direct import(), eg: dynamic(import('../hello-world'))
  // Note that this is only kept for the edge case where someone is passing in a promise as first argument
  // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
  // To make sure we don't execute the import without rendering first

  if (dynamicOptions instanceof Promise) {
    loadableOptions.loader = function () {
      return dynamicOptions;
    }; // Support for having import as a function, eg: dynamic(() => import('../hello-world'))

  } else if (typeof dynamicOptions === 'function') {
    loadableOptions.loader = dynamicOptions; // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
  } else if (typeof dynamicOptions === 'object') {
    loadableOptions = _objectSpread(_objectSpread({}, loadableOptions), dynamicOptions);
  } // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})


  loadableOptions = _objectSpread(_objectSpread({}, loadableOptions), options);
  var suspenseOptions = loadableOptions;

  if (true) {
    // Error if react root is not enabled and `suspense` option is set to true
    if ( true && suspenseOptions.suspense) {
      // TODO: add error doc when this feature is stable
      throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
  }

  if (suspenseOptions.suspense) {
    return loadableFn(suspenseOptions);
  } // coming from build/babel/plugins/react-loadable-plugin.js


  if (loadableOptions.loadableGenerated) {
    loadableOptions = _objectSpread(_objectSpread({}, loadableOptions), loadableOptions.loadableGenerated);
    delete loadableOptions.loadableGenerated;
  } // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false})


  if (typeof loadableOptions.ssr === 'boolean') {
    if (!loadableOptions.ssr) {
      delete loadableOptions.ssr;
      return noSSR(loadableFn, loadableOptions);
    }

    delete loadableOptions.ssr;
  }

  return loadableFn(loadableOptions);
}

/***/ }),

/***/ 3982:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LoadableContext = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var LoadableContext = _react["default"].createContext(null);

exports.LoadableContext = LoadableContext;

if (false) {}

/***/ }),

/***/ 23668:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__(2553);

var _createClass = __webpack_require__(62012);

var _defineProperty = __webpack_require__(61682);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _useSubscription = __webpack_require__(67161);

var _loadableContext = __webpack_require__(3982);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;

function load(loader) {
  var promise = loader();
  var state = {
    loading: true,
    loaded: null,
    error: null
  };
  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  })["catch"](function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });
  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj["default"] : obj;
}

function createLoadableComponent(loadFn, options) {
  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    webpack: null,
    modules: null,
    suspense: false
  }, options);

  if (opts.suspense) {
    opts.lazy = _react["default"].lazy(opts.loader);
  }

  var subscription = null;

  function init() {
    if (!subscription) {
      var sub = new LoadableSubscription(loadFn, opts);
      subscription = {
        getCurrentValue: sub.getCurrentValue.bind(sub),
        subscribe: sub.subscribe.bind(sub),
        retry: sub.retry.bind(sub),
        promise: sub.promise.bind(sub)
      };
    }

    return subscription.promise();
  } // Server only


  if (false) {} // Client only


  if (!initialized && true && typeof opts.webpack === 'function' && "function" === 'function' && !opts.suspense) {
    var moduleIds = opts.webpack();
    READY_INITIALIZERS.push(function (ids) {
      var _iterator = _createForOfIteratorHelper(moduleIds),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var moduleId = _step.value;

          if (ids.indexOf(moduleId) !== -1) {
            return init();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
  }

  function LoadableImpl(props, ref) {
    init();

    var context = _react["default"].useContext(_loadableContext.LoadableContext);

    var state = (0, _useSubscription).useSubscription(subscription);

    _react["default"].useImperativeHandle(ref, function () {
      return {
        retry: subscription.retry
      };
    }, []);

    if (context && Array.isArray(opts.modules)) {
      opts.modules.forEach(function (moduleName) {
        context(moduleName);
      });
    }

    return _react["default"].useMemo(function () {
      if (state.loading || state.error) {
        return _react["default"].createElement(opts.loading, {
          isLoading: state.loading,
          pastDelay: state.pastDelay,
          timedOut: state.timedOut,
          error: state.error,
          retry: subscription.retry
        });
      } else if (state.loaded) {
        return _react["default"].createElement(resolve(state.loaded), props);
      } else {
        return null;
      }
    }, [props, state]);
  }

  function LazyImpl(props, ref) {
    return _react["default"].createElement(opts.lazy, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref
    }));
  }

  var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;

  LoadableComponent.preload = function () {
    return !opts.suspense && init();
  };

  LoadableComponent.displayName = 'LoadableComponent';
  return _react["default"].forwardRef(LoadableComponent);
}

var LoadableSubscription = /*#__PURE__*/function () {
  function LoadableSubscription(loadFn, opts) {
    _classCallCheck(this, LoadableSubscription);

    this._loadFn = loadFn;
    this._opts = opts;
    this._callbacks = new Set();
    this._delay = null;
    this._timeout = null;
    this.retry();
  }

  _createClass(LoadableSubscription, [{
    key: "promise",
    value: function promise() {
      return this._res.promise;
    }
  }, {
    key: "retry",
    value: function retry() {
      var _this = this;

      this._clearTimeouts();

      this._res = this._loadFn(this._opts.loader);
      this._state = {
        pastDelay: false,
        timedOut: false
      };
      var res = this._res,
          opts = this._opts;

      if (res.loading) {
        if (typeof opts.delay === 'number') {
          if (opts.delay === 0) {
            this._state.pastDelay = true;
          } else {
            this._delay = setTimeout(function () {
              _this._update({
                pastDelay: true
              });
            }, opts.delay);
          }
        }

        if (typeof opts.timeout === 'number') {
          this._timeout = setTimeout(function () {
            _this._update({
              timedOut: true
            });
          }, opts.timeout);
        }
      }

      this._res.promise.then(function () {
        _this._update({});

        _this._clearTimeouts();
      })["catch"](function (_err) {
        _this._update({});

        _this._clearTimeouts();
      });

      this._update({});
    }
  }, {
    key: "_update",
    value: function _update(partial) {
      this._state = _objectSpread(_objectSpread({}, this._state), {}, {
        error: this._res.error,
        loaded: this._res.loaded,
        loading: this._res.loading
      }, partial);

      this._callbacks.forEach(function (callback) {
        return callback();
      });
    }
  }, {
    key: "_clearTimeouts",
    value: function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    }
  }, {
    key: "getCurrentValue",
    value: function getCurrentValue() {
      return this._state;
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      var _this2 = this;

      this._callbacks.add(callback);

      return function () {
        _this2._callbacks["delete"](callback);
      };
    }
  }]);

  return LoadableSubscription;
}();

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function flushInitializers(initializers, ids) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init(ids));
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers, ids);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolveInitializers, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
  });
};

Loadable.preloadReady = function () {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new Promise(function (resolvePreload) {
    var res = function res() {
      initialized = true;
      return resolvePreload();
    }; // We always will resolve, errors should be handled within loading UIs.


    flushInitializers(READY_INITIALIZERS, ids).then(res, res);
  });
};

if (true) {
  window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}

var _default = Loadable;
exports["default"] = _default;

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(73579)


/***/ }),

/***/ 33148:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"xy":[{"id":98,"name":"Hong Kong","banks":[{"name":"Neat","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Integration with accounting software (Xero)"},{"name":"Statrys","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Advanced forex services with 24/7 Tradedesk"},{"name":"Airwallex","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":false,"other_features":"No limit on incoming and outgoing transactions"}]},{"id":237,"name":"UK","banks":[{"name":"Wise","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Pay invoices in over 60 countries with low transfer fees"},{"name":"Revolut","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Support cryptocurrency investment"}]},{"id":191,"name":"Singapore","banks":[{"name":"Aspire","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":false,"other_features":"Connect to PayPal, Shopify, Stripe, Lazada, Shopee"},{"name":"Instarem","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Great FX rates and low transfer fees in 55+ countries"}]},{"id":238,"name":"US","banks":[{"name":"Payoneer","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Additional supports for e-commerce businesses"},{"name":"Mercury","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":" Create a custom dashboard with API access"}]}],"BL":[{"id":238,"name":"US","banks":[{"name":"Payoneer","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Additional supports for e-commerce businesses"}]}],"R2":[{"id":238,"name":"US","banks":[{"name":"Payoneer","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Additional supports for e-commerce businesses"}]}],"P0":[{"id":238,"name":"US","banks":[{"name":"Payoneer","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Additional supports for e-commerce businesses"}]}],"uK":[{"id":238,"name":"US","banks":[{"name":"Payoneer","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Additional supports for e-commerce businesses"}]}],"pQ":[{"id":238,"name":"US","banks":[{"name":"Payoneer","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Additional supports for e-commerce businesses"}]}],"Cj":[{"id":98,"name":"Hong Kong","banks":[{"name":"Statrys","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Advanced forex services with 24/7 Tradedesk"}]},{"id":238,"name":"US","banks":[{"name":"Payoneer","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Additional supports for e-commerce businesses"}]}],"pU":[{"id":238,"name":"US","banks":[{"name":"Payoneer","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Additional supports for e-commerce businesses"}]}],"TI":[{"id":98,"name":"Hong Kong","banks":[{"name":"Airwallex","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":false,"other_features":"No limit on incoming and outgoing transactions"}]},{"id":237,"name":"UK","banks":[{"name":"Wise","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Pay invoices in over 60 countries with low transfer fees"},{"name":"Revolut","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Support cryptocurrency investment"}]},{"id":238,"name":"US","banks":[{"name":"Payoneer","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Additional supports for e-commerce businesses"},{"name":"Mercury","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":" Create a custom dashboard with API access"}]}],"OU":[{"id":238,"name":"US","banks":[{"name":"Payoneer","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Additional supports for e-commerce businesses"}]}],"js":[{"id":238,"name":"US","banks":[{"name":"Payoneer","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Additional supports for e-commerce businesses"}]}],"On":[{"id":98,"name":"Hong Kong","banks":[{"name":"Neat","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Integration with accounting software (Xero)"},{"name":"Statrys","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Advanced forex services with 24/7 Tradedesk"},{"name":"Airwallex","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":false,"other_features":"No limit on incoming and outgoing transactions"}]},{"id":238,"name":"US","banks":[{"name":"Payoneer","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Additional supports for e-commerce businesses"}]},{"id":191,"name":"Singapore","banks":[{"name":"Instarem","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Great FX rates and low transfer fees in 55+ countries"}]}],"q8":[{"id":238,"name":"US","banks":[{"name":"Payoneer","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Additional supports for e-commerce businesses"}]}],"Rj":[{"id":98,"name":"Hong Kong","banks":[{"name":"Statrys","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Advanced forex services with 24/7 Tradedesk"},{"name":"Airwallex","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":false,"other_features":"No limit on incoming and outgoing transactions"}]},{"id":237,"name":"UK","banks":[{"name":"Wise","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Pay invoices in over 60 countries with low transfer fees"}]},{"id":191,"name":"Singapore","banks":[{"name":"Aspire","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":false,"other_features":"Connect to PayPal, Shopify, Stripe, Lazada, Shopee"},{"name":"Instarem","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Great FX rates and low transfer fees in 55+ countries"}]},{"id":238,"name":"US","banks":[{"name":"Payoneer","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Additional supports for e-commerce businesses"}]}],"UG":[{"id":98,"name":"Hong Kong","banks":[{"name":"Airwallex","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":false,"other_features":"No limit on incoming and outgoing transactions"}]},{"id":237,"name":"UK","banks":[{"name":"Revolut","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Support cryptocurrency investment"}]},{"id":238,"name":"US","banks":[{"name":"Payoneer","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Additional supports for e-commerce businesses"}]}],"eD":[{"id":238,"name":"US","banks":[{"name":"Payoneer","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Additional supports for e-commerce businesses"}]}],"eS":[{"id":98,"name":"Hong Kong","banks":[{"name":"Airwallex","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":false,"other_features":"No limit on incoming and outgoing transactions"}]},{"id":238,"name":"US","banks":[{"name":"Payoneer","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Additional supports for e-commerce businesses"}]}],"uT":[{"id":98,"name":"Hong Kong","banks":[{"name":"Airwallex","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":false,"other_features":"No limit on incoming and outgoing transactions"}]},{"id":238,"name":"US","banks":[{"name":"Payoneer","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Additional supports for e-commerce businesses"}]}],"Xu":[{"id":98,"name":"Hong Kong","banks":[{"name":"Airwallex","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":false,"other_features":"No limit on incoming and outgoing transactions"}]},{"id":237,"name":"UK","banks":[{"name":"Wise","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Pay invoices in over 60 countries with low transfer fees"},{"name":"Revolut","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Support cryptocurrency investment"}]},{"id":238,"name":"US","banks":[{"name":"Payoneer","online_registration":true,"multiple_account":true,"support_transactions":true,"physical_card":true,"other_features":"Additional supports for e-commerce businesses"}]}]}');

/***/ })

}]);